var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 160c44.183 0 80-35.817 80-80S124.183 0 80 0 0 35.817 0 80s35.817 80 80 80z",
    fill: "#141E30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.376 33.169v15.08H41.268v78.581h71.322V33.169H56.376z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.376 33.169l-15.108 15.08h15.108v-15.08zM101.489 91.784H52.2a2.053 2.053 0 100 4.105h49.289a2.052 2.052 0 000-4.105zM101.489 100.412H52.2a2.052 2.052 0 100 4.105h49.289a2.053 2.053 0 000-4.105zM79.735 109.069H52.2a2.052 2.052 0 100 4.105h27.535a2.053 2.053 0 000-4.105zM98.744 87.669l4.758-4.76-9.715-9.714-4.758 4.759 9.715 9.715z",
    fill: "#141E30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.167 85.668c11.798 0 21.363-9.564 21.363-21.363 0-11.798-9.565-21.363-21.363-21.363-11.799 0-21.363 9.565-21.363 21.363 0 11.799 9.564 21.363 21.363 21.363z",
    fill: "#141E30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.163 80.809c9.115 0 16.504-7.39 16.504-16.504 0-9.115-7.39-16.504-16.504-16.504-9.115 0-16.504 7.389-16.504 16.504 0 9.115 7.39 16.504 16.504 16.504z",
    fill: "#F2F6F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.259 80.138l-7.26 7.261a.692.692 0 000 .95l19.603 19.603a.69.69 0 00.949 0l7.261-7.26a.693.693 0 000-.95l-19.604-19.604c-.251-.25-.67-.25-.949 0z",
    fill: "#65AFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.065 91.436l13.506 13.506 8.214-8.214-13.506-13.507-8.214 8.215z",
    fill: "#5E7CE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.74f9fb39.svg";
export { ForwardRef as ReactComponent };